import { render, staticRenderFns } from "./memberMonicpaMHVA.vue?vue&type=template&id=18f796fa"
import script from "./memberMonicpaMHVA.vue?vue&type=script&lang=js"
export * from "./memberMonicpaMHVA.vue?vue&type=script&lang=js"
import style0 from "./memberMonicpaMHVA.vue?vue&type=style&index=0&id=18f796fa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports